import { p as proxyCustomElement, H, c as createEvent, h } from './p-ae815584.js';
import { D as DeprecationLogger } from './p-c44c2366.js';

const logger = new DeprecationLogger('deprecated-component', {
    'obsoleteProp': {
        type: 'property',
        message: '`obsoleteProp` will be removed.',
        resolveDate: 'June, XXXX',
    },
    'replacedProp': {
        type: 'property',
        message: '`replacedProp` will be replaced by `newProp`.',
        resolveDate: 'June, XXXX',
    },
    'updatedPropValue': {
        type: 'property',
        message: 'The value "old-value" for the property `updatedPropValue` will be replaced by "new-value".',
        warnCondition: (value) => {
            return value === 'old-value';
        },
        resolveDate: 'June, XXXX',
    },
    'deprecatedPropValue': {
        type: 'property',
        message: 'The property values "deprecated-value-a" and "deprecated-value-b" for the property `deprecatedPropValue` will be removed.',
        resolveDate: 'June, XXXX',
        deprecatedValues: ['deprecated-value-a', 'deprecated-value-b'],
    },
    'obsolete-event': {
        type: 'event',
        message: '`obsolete-event` will be removed.',
        resolveDate: 'June, XXXX',
    },
    'replaced-event': {
        type: 'event',
        message: '`replaced-event` will be removed.',
        resolveDate: 'June, XXXX',
    },
    'obsoleteMethod': {
        type: 'method',
        message: '`obsoleteMethod` will be removed.',
        resolveDate: 'June, XXXX',
    },
    'deprecated-part': {
        type: 'part',
        message: '`deprecated-part` will be removed.',
        resolveDate: 'June, XXXX',
    },
});
const DeprecatedComponent$1 = /*@__PURE__*/ proxyCustomElement(class DeprecatedComponent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.newEvent = createEvent(this, "new-event", 7);
        this.obsoleteEvent = createEvent(this, "obsolete-event", 7);
        this.replacedEvent = createEvent(this, "replaced-event", 7);
        this.deprecatedPropValue = 'value-c';
        this.newProp = undefined;
        this.obsoleteProp = undefined;
        this.replacedProp = undefined;
        this.updatedPropValue = 'new-value';
    }
    watchObsoleteProp() {
        logger.warnProperty('obsoleteProp');
    }
    watchToBeReplacedProp() {
        logger.warnProperty('replacedProp');
    }
    watchUpdatedPropValue(newValue) {
        logger.warnProperty('updatedPropValue', newValue);
    }
    watchDeprecatedPropValue(newValue) {
        logger.warnProperty('deprecatedPropValue', newValue);
    }
    /**
     * description
     * @deprecated deprecation message
     */
    async obsoleteMethod() {
        logger.warnMethod('obsoleteMethod');
    }
    obsoleteEventHandler() {
        logger.warnEvent('obsolete-event');
    }
    replacedEventHandler() {
        logger.warnEvent('replaced-event');
    }
    componentDidLoad() {
        logger.warnProperties(this);
        logger.warnParts(this.element);
    }
    render() {
        return h("div", { key: 'fd1eeb2bd41219af4d2ea5eb63d6d80f077ece09', class: "deprecated-component", part: "deprecated-part new-part" });
    }
    get element() { return this; }
    static get watchers() { return {
        "obsoleteProp": ["watchObsoleteProp"],
        "replacedProp": ["watchToBeReplacedProp"],
        "updatedPropValue": ["watchUpdatedPropValue"],
        "deprecatedPropValue": ["watchDeprecatedPropValue"]
    }; }
}, [1, "deprecated-component", {
        "deprecatedPropValue": [513, "deprecated-prop-value"],
        "newProp": [513, "new-prop"],
        "obsoleteProp": [513, "obsolete-prop"],
        "replacedProp": [513, "replaced-prop"],
        "updatedPropValue": [513, "updated-prop-value"],
        "obsoleteMethod": [64]
    }, [[0, "obsolete-event", "obsoleteEventHandler"], [0, "replaced-event", "replacedEventHandler"]], {
        "obsoleteProp": ["watchObsoleteProp"],
        "replacedProp": ["watchToBeReplacedProp"],
        "updatedPropValue": ["watchUpdatedPropValue"],
        "deprecatedPropValue": ["watchDeprecatedPropValue"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["deprecated-component"];
    components.forEach(tagName => { switch (tagName) {
        case "deprecated-component":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, DeprecatedComponent$1);
            }
            break;
    } });
}

const DeprecatedComponent = DeprecatedComponent$1;
const defineCustomElement = defineCustomElement$1;

export { DeprecatedComponent, defineCustomElement };
